/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Delivery_DriverInputs */

const vi_report_delivery_driver = /** @type {(inputs: Report_Delivery_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài xế`)
};

/**

* @param {Report_Delivery_DriverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_delivery_driver = /** @type {((inputs?: Report_Delivery_DriverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Delivery_DriverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_delivery_driver(inputs)
});